
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.daysEl  = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl  = this.querySelector('.js-mins');
      this.secsEl  = this.querySelector('.js-secs');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour   = 60 * this.minute;
      this.day    = 24 * this.hour;

      this.resetMode = this.dataset.resetMode || 'custom';

      // ── REPEATING: count down from a fixed duration, then restart ──
      if (this.resetMode === 'repeating') {
        this._repeatMs = this._buildRepeatMs();
        if (!this._repeatMs) {
          console.warn('CountdownTimer: repeating duration is 0, set at least 1 minute.');
          return;
        }
        // Anchor to the start of the current page load so the cycle is
        // exactly the duration the merchant configured, starting now.
        this._cycleStart = Date.now();
        this.endDate = this._cycleStart + this._repeatMs;
        this.timer();
        this.interval = setInterval(this.timer.bind(this), this.second);
        return;
      }

      // ── MIDNIGHT: counts down to 00:00:00 of the next calendar day ──
      if (this.resetMode === 'midnight') {
        this.endDate = this._nextMidnight();
        this.timer();
        this.interval = setInterval(this.timer.bind(this), this.second);
        return;
      }

      // ── WEEKLY: counts down to next Sunday 00:00:00 ────────────────
      if (this.resetMode === 'weekly') {
        this.endDate = this._nextSunday();
        this.timer();
        this.interval = setInterval(this.timer.bind(this), this.second);
        return;
      }

      // ── CUSTOM: fixed end date set in theme editor ─────────────────
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!Number(this.endDate)) return;
      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    // ── Helpers ──────────────────────────────────────────────────────

    _buildRepeatMs() {
      const d = parseInt(this.dataset.repeatDays,    10) || 0;
      const h = parseInt(this.dataset.repeatHours,   10) || 0;
      const m = parseInt(this.dataset.repeatMinutes, 10) || 0;
      return (d * this.day) + (h * this.hour) + (m * this.minute);
    }

    // True midnight = 00:00:00.000 of the NEXT day (not 23:59 today)
    _nextMidnight() {
      const t = new Date();
      t.setDate(t.getDate() + 1);
      t.setHours(0, 0, 0, 0);
      return t.getTime();
    }

    _nextSunday() {
      const t   = new Date();
      const day = t.getDay();                        // 0=Sun … 6=Sat
      const daysUntilSunday = day === 0 ? 7 : 7 - day;
      t.setDate(t.getDate() + daysUntilSunday);
      t.setHours(23,59,59,999);
      return t.getTime();
    }

    // ── Core tick ────────────────────────────────────────────────────

    timer() {
      const now      = Date.now();
      let   timeDiff = this.endDate - now;

      if (timeDiff <= 0) {
        if (this.resetMode === 'repeating') {
          // Restart: new cycle begins from right now
          this._cycleStart = now;
          this.endDate     = now + this._repeatMs;
          timeDiff         = this._repeatMs;
        } else if (this.resetMode === 'midnight') {
          this.endDate = this._nextMidnight();
          timeDiff     = this.endDate - now;
        } else if (this.mode === 'weekly') {
            this.endDate = this._nextSunday();
            diff = this.endDate - now;

            // If we're already past this week's Sunday,
            // move to next week's Sunday
            if (diff <= 0) {
              this.endDate += 7 * this.D;
              diff = this.endDate - now;
            }
          } else {
          // Custom mode: stop the timer
          clearInterval(this.interval);
          return;
        }
      }

      const days  = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins  = Math.floor(timeDiff / this.minute);
      const secs  = Math.floor(timeDiff / this.second);

      if (this.daysEl)  this.daysEl.textContent  = days;
      if (this.hoursEl) this.hoursEl.textContent = hours - days * 24;
      if (this.minsEl)  this.minsEl.textContent  = mins  - hours * 60;
      if (this.secsEl)  this.secsEl.textContent  = secs  - mins  * 60;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}